import { catchAxiosError } from 'utilities/axios';
import axiosInstance from 'api-services/api-client';

export const getGeneralStatistics = async () => {
  return catchAxiosError(
    axiosInstance
      .get('/admin/statistics')
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const getActiveSubscriptions = async () => {
  return catchAxiosError(
    axiosInstance
      .get('/admin/active-subscriptions')
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const getPastSixMonthStats = async () => {
  return catchAxiosError(
    axiosInstance
      .get('/admin/past-six-month-stats')
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const getHottestSellingPlan = async () => {
  return catchAxiosError(
    axiosInstance
      .get('/admin/hottest-selling')
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};